import {
   Dialog,
   DialogTitle,
   DialogContent,
   DialogActions,
   Button,
   Box,
   Typography,
   Table,
   TableBody,
   TableCell,
   TableContainer,
   TableHead,
   TableRow,
   Paper,
   Chip,
   Skeleton,
} from '@mui/material';
import { useGetQuotationLogsQuery } from '../Redux/Service/QuotationApi';

function QuotationLogsModal({ open, quotationId, onClose }) {
   const { data, isLoading, isError, error } = useGetQuotationLogsQuery(quotationId, {
      skip: !open || !quotationId,
   });

   const logs = data?.response || [];

   const getStatusColor = (status) => {
      switch (status?.toLowerCase()) {
         case 'sent':
            return 'success';
         case 'failed':
            return 'error';
         case 'viewed':
            return 'info';
         default:
            return 'default';
      }
   };

   const formatDate = (dateString) => {
      return new Date(dateString).toLocaleString('en-US', {
         year: 'numeric',
         month: 'short',
         day: 'numeric',
         hour: '2-digit',
         minute: '2-digit',
         second: '2-digit',
      });
   };

   return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
         <DialogTitle sx={{ fontWeight: 600, borderBottom: '1px solid #e0e0e0' }}>
            Quotation Email Logs
         </DialogTitle>
         <DialogContent sx={{ py: 3 }}>
            {isLoading ? (
               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Skeleton variant="rectangular" height={50} />
                  <Skeleton variant="rectangular" height={50} />
                  <Skeleton variant="rectangular" height={50} />
               </Box>
            ) : isError ? (
               <Typography color="error">
                  Error loading logs: {error?.data?.message || 'Unknown error'}
               </Typography>
            ) : logs && logs.length > 0 ? (
               <TableContainer component={Paper} variant="outlined">
                  <Table>
                     <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                        <TableRow>
                           <TableCell sx={{ fontWeight: 600 }}>Date & Time</TableCell>
                           <TableCell sx={{ fontWeight: 600 }}>Sent To</TableCell>
                           <TableCell sx={{ fontWeight: 600 }}>Sent By</TableCell>
                           <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                        </TableRow>
                     </TableHead>
                     <TableBody>
                        {logs.map((log) => (
                           <TableRow key={log.id} hover>
                              <TableCell>
                                 <Typography variant="body2">
                                    {formatDate(log.createdAt)}
                                 </Typography>
                              </TableCell>
                              <TableCell>
                                 <Typography variant="body2">{log.sentToEmail}</Typography>
                              </TableCell>
                              <TableCell>
                                 <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                       {log.sentBy?.name || log.sentByLabel || 'Unknown'}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">
                                       {log.sentBy?.email}
                                    </Typography>
                                 </Box>
                              </TableCell>
                              <TableCell>
                                 <Chip
                                    label={log.status}
                                    size="small"
                                    color={getStatusColor(log.status)}
                                    variant="outlined"
                                 />
                              </TableCell>
                           </TableRow>
                        ))}
                     </TableBody>
                  </Table>
               </TableContainer>
            ) : (
               <Box sx={{ textAlign: 'center', py: 4 }}>
                  <Typography color="textSecondary">
                     No email logs found for this quotation
                  </Typography>
               </Box>
            )}
         </DialogContent>
         <DialogActions sx={{ borderTop: '1px solid #e0e0e0', p: 2 }}>
            <Button onClick={onClose} variant="contained">
               Close
            </Button>
         </DialogActions>
      </Dialog>
   );
}

export default QuotationLogsModal;
